import { TYPOGRAPHY_COLORS } from 'constants/TypographyColors'
import { SVGIcon } from './SvgIcon/SvgIcon'
import { IconProps } from './types'

export const PriceListIcon = ({
  size,
  color = 'grey400',
  className,
}: IconProps) => (
  <SVGIcon size={size} color={color} className={className} viewBox="0 0 20 20">
    <path
      d="M18.1914 5.44913V9.2457C18.1913 9.72842 17.9995 10.1912 17.6581 10.5325L12.4619 15.7287C11.6055 16.585 10.2171 16.585 9.36062 15.7287L6.09181 12.4599C5.2355 11.6034 5.2355 10.215 6.09181 9.35855L11.288 4.16235C11.6292 3.82103 12.0921 3.62917 12.5748 3.62909H16.3714C17.3766 3.62909 18.1914 4.44399 18.1914 5.44913Z"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M4.54142 15.4593L3.09265 14.0106C1.38004 12.2977 1.38004 9.52077 3.09265 7.80792L7.27148 3.62909"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
    <path
      d="M14.5514 7.26917H14.5605"
      stroke={TYPOGRAPHY_COLORS[color]}
      strokeWidth="1.75"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill="none"
    />
  </SVGIcon>
)
